// utcTarih.js — "30 SEP 2026" BİÇİMİ, UTC — TEK KAYNAK (30 Eyl 2026)
//
// 🔑 Serkan: "Her zaman UTC takip edeceğiz." Web'in bütün kısa ay adlı tarihleri buradan
//    yazılır (süper admin ekranları, dashboard, CREWS, FTL, System Monitoring, CZIB).
// 🔴 ÖNCESİ: aynı fonksiyon AppReleases ve AircraftTypes'ta iki kopya duruyordu.
// 🔴 AY ADI SABİT LİSTEDEN (30 Eyl 2026'da görüldü): `toLocaleString('en-GB',{month:'short'})`
//    yeni tarayıcılarda Eylül'ü "Sept" veriyordu → "30 SEPT 2026", öteki aylar üç harf. Aynı
//    tarayıcı ay adı 5 yerde daha vardı (dashboard "Archived" — üstelik YEREL saatle —, CREWS
//    FTL BASELINE rozeti, FTL paneli, System Monitoring, CZIB); hepsi buraya bağlandı.
//    Ay adı tarayıcının diline, saat tarayıcının dilimine bırakılmaz.
// Biçimler ekranların BUGÜNKÜ biçimleridir — yalnız ay adı ve saat dilimi düzeldi.
// Boş ya da okunamayan değer "—" olur, uydurulmaz.
const AYLAR = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
const iki = n => String(n).padStart(2, '0');
const coz = iso => {
  if (!iso) return null;
  const d = new Date(iso);
  return isNaN(d) ? null : d;
};

/** "30 SEP 2026" */
export function utcGun(iso) {
  const d = coz(iso);
  return d ? `${iki(d.getUTCDate())} ${AYLAR[d.getUTCMonth()]} ${d.getUTCFullYear()}` : '—';
}
/** "30 SEP" */
export function utcGunAy(iso) {
  const d = coz(iso);
  return d ? `${iki(d.getUTCDate())} ${AYLAR[d.getUTCMonth()]}` : '—';
}
/** "30 SEP, 14:05" · saniye: "30 SEP, 14:05:09" · z: sonuna "Z" */
export function utcGunAySaat(iso, { saniye = false, z = false } = {}) {
  const d = coz(iso);
  if (!d) return '—';
  const saat = `${iki(d.getUTCHours())}:${iki(d.getUTCMinutes())}${saniye ? ':' + iki(d.getUTCSeconds()) : ''}`;
  return `${utcGunAy(d)}, ${saat}${z ? 'Z' : ''}`;
}
/** "14:05" · saniye: "14:05:09" — tarihi ayrıca yazılan ya da yanında "UTC" duran saatler için */
export function utcSaat(iso, { saniye = false } = {}) {
  const d = coz(iso);
  return d ? `${iki(d.getUTCHours())}:${iki(d.getUTCMinutes())}${saniye ? ':' + iki(d.getUTCSeconds()) : ''}` : '—';
}
/** "30 SEP 2026, 14:05" · z: sonuna "Z" */
export function utcGunSaat(iso, { z = false } = {}) {
  const d = coz(iso);
  return d ? `${utcGun(d)}, ${iki(d.getUTCHours())}:${iki(d.getUTCMinutes())}${z ? 'Z' : ''}` : '—';
}
